module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_braveM.cfa5e94a595ece92a2b16d15aa4a33d9.png";